export const DRAWING_TEXT_AREA_MIN_HEIGHT = 10;
export const DRAWING_TEXT_AREA_MIN_WIDTH = 10;

export const DRAWING_CALLOUT_ARROW_PERCENTAGE = 20;
export const DRAWING_CALLOUT_TEXTBOX_PERCENTAGE = 100 - DRAWING_CALLOUT_ARROW_PERCENTAGE;
